import skeleton from '../../../components/skeleton';
import vueSeamlessScroll from "vue-seamless-scroll";
import banner from "../../../components/banner";
import caseList from "../../../components/caseList";
import news from "../../../components/news";
import pay from "../../../components/pay";
import QRCode from "../../../components/QRCode";
import maskPDF from "../../../components/maskPDF";
import customerTalk from "../../../components/customerTalk";
import './caseRestaurant.less'
export default {
    name: "caseRestaurant",
    data() {
        return {
            black:{
                title: '收款小精灵为各种不同类型的餐饮企业提供整合的门店数字化工具。在激烈的行业竞争中，用户为王',
                info: '我们从餐饮门店的移动支付到扫码点餐，从升级电子化储值营销到自动化数据报表，从小程序外卖到多门店的管理平台，整体化赋能餐饮企业。'
            },
            info: [
                {
                    title: '自有的小程序外卖',
                    pic: 'img/caseRestaurant/info1.png',
                    info: '与线下支付用户和门店会员完全打通，可以沉淀和持续运营您自己的用户流量。对比使用平台外卖，可以极大降低成本。',
                    block: ''
                },
                {
                    title: '会员营销',
                    pic: 'img/caseRestaurant/info2.png',
                    info: '不论是餐饮小店，还是餐饮连锁店，我们都可以按照您的业务提供数字化营销工具，满足门店拉新、复购、提升客单价、客户忠诚度的需求。',
                    block: 'swap'
                },
                {
                    title: '连接支付',
                    pic: 'img/caseRestaurant/info3.png',
                    info: '您可以选择更换收银系统或不更换，我们都有灵活的方式提供移动支付工具，从而一体化的管理门店的用户和会员。',
                    block: ''
                },
                {
                    title: '多门店管理平台',
                    pic: 'img/caseRestaurant/info4.png',
                    info: '对于连锁餐饮企业，我们可以提供多门店的门店、员工、菜品、资金清分结算、数据的统一管理平台。',
                    block: 'swap'
                }
            ],
            rollList: [
                {
                    src: "/img/caseRestaurant/lun1.png",
                    size: 4,
                },
                {
                    src: "/img/caseRestaurant/lun2.png",
                    size: 2,
                },
                {
                    src: "/img/caseRestaurant/lun3.png",
                    size: 3,
                },
                {
                    src: "/img/caseRestaurant/lun4.png",
                    size: 4,
                }
            ],
            caseData: {
                title: '餐饮行业概述',
                info: [
                    {
                        title: '小精灵数字餐饮概述',
                        pic: 'img/caseRestaurant/case1.png',
                        linkTxt: '行业概述',
                        linkType: 'href',
                        linkHref: 'https://www.yuque.com/lt/jjfa/wgtev3'
                    },
                    {
                        title: '小精灵正餐&轻餐概述',
                        pic: 'img/caseRestaurant/case2.png',
                        linkTxt: '行业概述',
                        linkType: 'href',
                        linkHref: 'https://www.yuque.com/lt/jjfa/lcvhn5'
                    },
                    {
                        title: '小精灵小吃&饮品概述',
                        pic: 'img/caseRestaurant/case3.png',
                        linkTxt: '行业概述',
                        linkType: 'href',
                        linkHref: 'https://www.yuque.com/lt/jjfa/ohlus8'
                    },
                    {
                        title: '小精灵烘培行业概述',
                        pic: 'img/caseRestaurant/case4.png',
                        linkTxt: '行业概述',
                        linkType: 'href',
                        linkHref: 'https://www.yuque.com/lt/jjfa/fo6l9e'
                    }
                ]
            },
            food: {
                title: '美食广场',
                more: '更多美食广场案例',
                num: 3,
                info: [
                    {
                        pic: "/img/caseRestaurant/food1.png",
                        title: "年过五旬再次创业，【地酷美食广场】仅半年时间连开三家美食广场",
                        txt: "深圳核心CBD商圈，商城地下美食城，短短4个月，从上线小精灵电子会员卡，业绩迅速翻倍，他们是如何做到的？",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRestaurant/food2.png",
                        title: "1元钱引爆3万开卡量，烟台【十字街】夜市这样提高客户粘性",
                        txt: "一条美食街，40个档口，总部统一管理，门店小程序对账，用1元钱撬动3万开卡量，冷门时间段做折扣，拉动全部时间段销售额，他们是怎么玩的呢？",
                        pdf: "",
                    },

                    {
                        pic: "/img/caseRestaurant/food3.png",
                        title: "上海市【漕河泾开发区】一张电子餐卡解决20万人吃饭问题",
                        txt: "漕河泾创新创意产业园覆盖20万行业从业者、3000家企业、20家餐厅、252家档口。API接口上线电子餐卡，这么简单，不敢相信？！",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRestaurant/food4.png",
                        title: "【沈阳吃货红人馆】美食街7天时间裂变3000会员，他们只用了一招",
                        txt: "1个美食广场，21个档口，全部使用语音码牌+小程序结合使用的场景，配置活动【支付即会员】，一个国庆，快速吸粉3000+",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRestaurant/food5.png",
                        title: "一个小程序满足高效食堂的所有需求，「收款小精灵」与【西南民大校园餐厅】的故事",
                        txt: "推荐5人开卡，即可得到1根冰淇凌兑换券，仅用2个月时间，覆盖校园2万余人（校园占比达60%）后期通过商城，售卖校园周边，实现变现。",
                        pdf: "",
                    },
                ]
            },
            customerTalk1: {
                bg: 'rgb(245, 240, 225)',
                pic: 'img/caseRestaurant/person1.png',
                info: '“美食城、美食街、都面临三个问题，一是，总部和门店分账；二是，如何让客户更高效和便利；三是，总部如何通过是数据驱动经营，实现增长；「收款小精灵」同时解决了这三个问题，这是我们能合作的根本原因”',
                person: '— 潘先生，十字街，运营总监'
            },
            fast: {
                title: '轻餐快餐',
                more: '更多轻餐快餐案例',
                num: 3,
                info: [
                    {
                        pic: "/img/caseRestaurant/fast1.png",
                        title: "从闭店2个月到吸储1000万，揭秘【失重】网红餐厅的求生法则",
                        txt: "号称“从天而降的美食”，吸引各种明星网红打卡、抖音年度“心动餐厅”，从北京2个店，到全国30+门店，从闭店2个月到吸储上千万，他究竟有什么经营秘诀呢？",
                        pdf: "https://liantuo-1253818706.cos.ap-nanjing.myqcloud.com/media/anli/失重.pdf",
                    },
                    {
                        pic: "/img/caseRestaurant/fast2.png",
                        title: "哈尔滨【赛百味】壕砸地铁广告的背后，仅仅只是为了一张电子会员卡！",
                        txt: "入华26年，赛百味一直再寻找突破之路，前有麦当劳和肯德基，后又华莱士。如何破局？2019年底，哈尔滨地铁的刷屏了赛百味的广告，扫码一看竟然是电子会员开卡，这是卖的什么关子呢？",
                        pdf: "https://liantuo-1253818706.cos.ap-nanjing.myqcloud.com/media/anli/赛百味.pdf",
                    },

                    {
                        pic: "/img/caseRestaurant/fast3.png",
                        title: "CBD商圈里的快餐店—【四旺快餐】，这个店一年吸储500万！",
                        txt: "定位白领客户的快餐店，附近商户同质化严重，外卖竞争也很激烈，22家门店又如何做拓张？一年时间，会员开卡6万+，储值近500万，沉淀20%，他是怎么做到的呢？",
                        pdf: "",
                    },
                ]
            },
            customerTalk2: {
                bg: 'rgb(225, 229, 245)',
                pic: 'img/caseRestaurant/person2.png',
                info: '“原餐厅的点餐系统，搭载小精灵电子会员体系，实现门店无收银，用户全自主：自主点餐、开卡、支付、推荐储值、支付送券、后厨备餐、用户取餐享用，打造了极致的顾客体验”',
                person: '— 马女士，失重餐厅蓝港店， 店长'
            },
            snack: {
                title: '小吃饮品',
                more: '更多小吃饮品案例',
                num: 3,
                info: [
                    {
                        pic: "/img/caseRestaurant/snack1.png",
                        title: "半年时间覆盖哈尔滨20万人，【对青烤鹅】的三张“王牌”",
                        txt: "“对青烤鹅”创始于黑龙江省的 “对青山镇”。所有出差的人基本都会从他们家带上一直烤鹅做为特产带回家，一张“大鹅卡”覆盖哈尔滨20万人次，他们是怎么做到的呢？",
                        pdf: "https://liantuo-1253818706.cos.ap-nanjing.myqcloud.com/media/anli/对青烤鹅.pdf",
                    },
                    {
                        pic: "/img/caseRestaurant/snack2.png",
                        title: "20平小店也能拉动20000储值，【撒露酸奶】从百店到千店的进击之路",
                        txt: "Salud（撒露）是风靡欧洲的冻酸奶品牌，创始于“美食天堂”西班牙。15年进入中国，迅速开店，平均每个店20000储值，百店冲击千店，后背的武器是什么？",
                        pdf: "https://liantuo-1253818706.cos.ap-nanjing.myqcloud.com/media/anli/撒露冻酸奶.pdf",
                    },

                    {
                        pic: "/img/caseRestaurant/snack3.png",
                        title: "【御质贡茶】用一个小程序实现坪效和消费160%增长",
                        txt: "御质贡茶近年新崛的绿色健康饮品品牌，深受消费者喜爱。一个点餐小程序，店均300单到500单的增长，背后都做了些什么改变？",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRestaurant/snack4.png",
                        title: "从跌落神坛到口碑爆棚，【廖记棒棒鸡】的数字化秘籍",
                        txt: "每周二会员日9.5折优惠，每周二一早8:00点的服务通知群发触达，带动每周二130%的营业额增长",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRestaurant/snack5.png",
                        title: "【黑龙江道台府】遇见「小精灵」150天，付费会员突破10万",
                        txt: "5「道台府」在哈尔滨了100多家直营店，被哈尔滨市政府评为“小明珠企业”“哈尔滨货真价实满意店”…使用小精灵，9.9元付费会员6个月破10万",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRestaurant/snack6.png",
                        title: "早餐卖出上千元，【昆明盘龙凤姐小吃】25平小店也能月入几十万",
                        txt: "在昆明，你会听到这样一句话。“每天叫醒你的不是梦想，是每个昆明的清晨”疫情期间借助小精灵外卖小程序，每天160多单外卖，成功度过危机",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRestaurant/snack7.png",
                        title: "30岁开始创业，【茶桔梗】在竞争激烈的奶茶行业撕出了一道口子",
                        txt: "2017年下半年，张静不顾父母和朋友的劝阻，拿出了积攒出来的20万元加盟了“茶桔梗奶茶店”。借助小精灵会员营销，推荐裂变，一个月吸粉破万。",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRestaurant/snack8.png",
                        title: "加盟品牌也能拥有独立的会员系统，甘肃【米芝莲】做到了",
                        txt: "低门槛，高额度的储值策略，结合爆款单品优惠券，一周时间开卡破万，做到50%的储值会员占比！",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRestaurant/snack9.png",
                        title: "520当天核销100张优惠券，【十洋咖啡】馆收获200位情侣会员",
                        txt: "十洋ED为更多热爱生活，热爱艺术的青年提供一个加朋友的场所。合作小精灵，一个节日引爆单身群体，收获6000+会员...",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRestaurant/snack10.png",
                        title: "90后姑娘在三线城市开冷饮店，5个月时间吸储40万",
                        txt: "每7天一张定时营销的优惠券，互动其社群内发布互动营销小游戏活动，2场游戏活动，16000人次参加",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRestaurant/snack11.png",
                        title: "不做任何营销推广，社区串串店每日轻松过万，「退伍老兵的生意经」",
                        txt: "2018年，张平结束了7年的军营生活回到了四川老家，开了一家串串香。借助小精灵会员告别传统记账会员，通过服务通知，实现每周二会员日的120%的增长...",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRestaurant/snack12.png",
                        title: "一家包子铺8个月吸储100万，员工道出了其中真相",
                        txt: "门店销售冠军的阿姨说：“客人能享受优惠，我能每天多挣几十块，谁都愿意在上菜和结账的时候多说两句，尤其很多顾客还是社区的老面孔了”",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRestaurant/snack13.png",
                        title: "双十一当天核销1万张优惠券，【一手店】是如何做到的？",
                        txt: "一手店的门店执行能力，是20万会员背后更大的推手。借助朋友圈广告和附近发券，曝光同时，实现营收增长",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRestaurant/snack14.png",
                        title: "疫情期间关店15家，【卤御烧肉】在线上找到新阵地",
                        txt: "主打高毛利、高口碑的单品优惠券，结合小精灵搭建的商户自营线上外卖小程序，疫情期间，线上商城贡献了50%的交易额…",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRestaurant/snack15.png",
                        title: "把实惠留给老顾客，【永存驴肉火烧】靠复购券实力圈粉",
                        txt: "精准会员标签，结合定时营销，给15天、30天不到店的顾客定时发券，经营好门店70%的老顾客的生意",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRestaurant/snack16.png",
                        title: "保定“栗子王”用半年时间储值40万，快速扩充3家门店",
                        txt: "语音码牌+支付即会员，快捷简单做会员拉新，小额储值，半年回笼资金40万，快速拓3店",
                        pdf: "",
                    },
                ]
            },
            customerTalk3: {
                bg: 'rgb(245, 240, 225)',
                pic: 'img/caseRestaurant/person3.png',
                info: '“所有人都在寻找新渠道、新流量、新增长点的时候，不能忽略「存量即增量」，通过数字营销的方式把老客户盘活，让企业实现二次增长。”',
                person: '— 方女士，对青烤鹅，运营经理'
            },
            dessert: {
                title: '烘焙甜品',
                more: '更多烘焙甜品案例',
                num: 3,
                info: [
                    {
                        pic: "/img/caseRestaurant/dessert1.png",
                        title: "前有85度C后有克莉丝汀，『面包新语』如何在苏州一骑绝尘？",
                        txt: "面包新语在苏州开出了20家门店，烘培行业竞争激烈，19年初，经过和小精灵服务商多次沟通协商后，每家店上演PK机制，每个人都有自己的KPI，单品券核销率到32%",
                        pdf: "https://liantuo-1253818706.cos.ap-nanjing.myqcloud.com/media/anli/面包新语.pdf",
                    },
                    {
                        pic: "/img/caseRestaurant/dessert2.png",
                        title: "对标星巴克，网红蛋糕【上海红跑车】用会员储值实力圈粉",
                        txt: "《亲爱的、热爱的》、《都挺好》等一众电视剧取景地，定位轻奢、白领、年轻群体。牵手小精灵，搭建线上线下一体化的会员体系，充分利用员工分销和社群裂变能力，单店一年时间储值金额上千万",
                        pdf: "https://liantuo-1253818706.cos.ap-nanjing.myqcloud.com/media/anli/上海红跑车.pdf",
                    },

                    {
                        pic: "/img/caseRestaurant/dessert3.png",
                        title: "20年老牌烘焙品牌【向阳坊】破局营销，10个月时间储值破千万",
                        txt: "二十多年来，向阳坊始终品质如一的服务着新老顾客，如何实现区域连锁走向全国连锁的扩张，一直是难题.2019年夏天是个转折点，10个月时间开卡5万，储值破千万",
                        pdf: "https://liantuo-1253818706.cos.ap-nanjing.myqcloud.com/media/anli/向阳坊.pdf",
                    },
                    {
                        pic: "/img/caseRestaurant/dessert4.png",
                        title: "做好员工分销，一家烘焙小店也能月储值",
                        txt: "「位于安徽省安庆市的【阿拉呱呱蛋糕】老板是一对90后夫妻。阿拉呱呱通过对顾客和员工的双激励，仅一个月的时间就实现储值71万元...",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRestaurant/dessert5.png",
                        title: "一页PPT撬动百万储值，涿州【步步高】西饼做到了",
                        txt: "步步高，通过微信服务通知实现会员零成本的100%触达，分层更精准，触达更有效，让每一条消息都有价值",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRestaurant/dessert6.png",
                        title: "50平蛋糕小店每日营收2万元，【多麦甜】只用了这一招",
                        txt: "每一个节日，有能收到多麦田的温情营销内容和优惠券，节日营销通过服务通知触达，事半功倍",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRestaurant/dessert7.png",
                        title: "90后为何钟爱老字号？百年【稻香村】的营销秘籍",
                        txt: "借助小精灵实现线上线下一体化会员布局，通过会员体系和线上拼团秒杀，传统老字号也可以更有趣",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRestaurant/dessert8.png",
                        title: "3秒开卡，月储值几十万，【法贝德】在兰州比拉面还有名",
                        txt: "支付即会员和3秒开卡，改变原来3-5分钟的开卡时间，大大提高门店人效，会员线上线下通用，法贝德的销售额总是比同等门店要高20%",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRestaurant/dessert9.png",
                        title: "提前布局私域流量，【金象蛋糕】疫情期间营业额增长30%",
                        txt: "早在2019年2月，金象蛋糕就打通14家门店的收银数据，同时布局线上小程序商城，疫情期间，直接带来30%外卖业务增长",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRestaurant/dessert10.png",
                        title: "二胎宝妈华丽转身，帮老东家收获5000会员",
                        txt: "开卡有礼、推荐有礼、附近发券、朋友圈广告、海报无聊、收银员口碑...拉新组合拳，多渠道沉淀会员开卡",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRestaurant/dessert11.png",
                        title: "20年的烘焙老店，【毛玖】只用一招化解「中年危机」",
                        txt: "社区店，建立社群，使用小精灵推荐裂变开卡，员工分销、结合互动小游戏，抓住社群的客户",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRestaurant/dessert12.png",
                        title: "22岁小伙新店开张，【奇香饼家】一天送出100个蛋挞，裂变600会员",
                        txt: "利用小精灵推荐有礼，邀请5个好友开卡即可获得一盒蛋挞，开卡当天送出100多个蛋挞，收获社区600多个会员",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRestaurant/dessert13.png",
                        title: "双十一当天卖出上万张代金券，30年老店【永盛蛋糕】背后的营销故事",
                        txt: "消费得积分，定时积分翻倍，搭建积分商城，积分兑换单品券、全场代金券，让积分动起来",
                        pdf: "",
                    },
                ]
            },
            customerTalk4: {
                bg: 'rgb(225, 229, 245)',
                pic: 'img/caseRestaurant/person4.png',
                info: '“从成立之初，红跑车的定位就是对标星巴克。打造轻奢、网红特质。既能让顾客在空间上享受网红待遇，又能在味蕾上牢牢锁住用户，最后用小精灵消费返利（返券）的营销方式圈粉，锁定用户消费”',
                person: '— 梁先生，红跑车，品牌运营经理'
            },
            dinner: {
                title: '正餐和团餐',
                more: '更多正餐和团餐案例',
                num: 3,
                info: [
                    {
                        pic: "/img/caseRestaurant/dinner1.png",
                        title: "扎根在黑土地的【九转小磨】，“付费会员”模式被央视《新闻1+1》报道",
                        txt: "「九转小磨」2008年创建于号称“东方小巴黎”的时尚之都——哈尔滨。从开业初期的单店800平发展到现在的总营业面积30000余平方米。“年夜饭”推出新吃法，「九转小磨」与10万付费会员的背后故事...",
                        pdf: "https://liantuo-1253818706.cos.ap-nanjing.myqcloud.com/media/anli/九转小磨.pdf"
                    },
                    {
                        pic: "/img/caseRestaurant/dinner2.png",
                        title: "【老佛爷铜炉蛙锅】制定四级战略，3个月内会员突破14000人，储值80万",
                        txt: "2015年，老佛爷作为铜炉蛙锅的鼻祖，截至目前，在全国已经有200多家门店。潜心研制8个月、闭关试蛙千斤后，首创“蛙锅节”,结合付费礼包的玩法，瞬间刷爆抖音、小红书...",
                        pdf: "https://liantuo-1253818706.cos.ap-nanjing.myqcloud.com/media/anli/老佛爷.pdf",
                    },

                    {
                        pic: "/img/caseRestaurant/dinner3.png",
                        title: "米其林餐厅【芒果树】，刷新奢华泰式餐饮新高度",
                        txt: "作为享誉国际的米其林餐厅，位于广州K11艺术中心的「芒果树Mango Tree」是首屈一指的优质泰菜食府，数次被评为泰国优秀餐厅。借助「说款小精灵」深耕业务，一年时间实现10万付费会员...",
                        pdf: "https://liantuo-1253818706.cos.ap-nanjing.myqcloud.com/media/anli/芒果树.pdf",
                    },
                    {
                        pic: "/img/caseRestaurant/dinner4.png",
                        title: "【黄记煌】的中餐标准化，不需要厨师的餐厅如何成功？",
                        txt: "每个员工一个员码，精准到所有员工的开卡、卖券、推荐处置，每个员工日均开卡量7.5张，黄记煌的借助小精灵让门店人效提高150%",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRestaurant/dinner5.png",
                        title: "6年开出数百家门店，东北新餐饮“排队王”【多嘴蟹肉煲】是怎么炼成的？",
                        txt: "对其平台优惠，玩转每满减，省掉平台扣点，沉淀自有会员流量；巧用付费大礼包，实现“充多少送多少”的超级噱头营销！",
                        pdf: ""
                    },
                    {
                        pic: "/img/caseRestaurant/dinner6.png",
                        title: "一个月时间开卡5万+，【九点半】酒吧餐厅告诉你在顶级商圈中该如何运营店铺",
                        txt: "Ninethirty「9点半餐厅酒吧」借助小精灵实现超级消费返利，笔笔消费笔笔返利，实现持续性锁客！",
                        pdf: "",
                    },

                    {
                        pic: "/img/caseRestaurant/dinner7.png",
                        title: "每月一个节日礼包，【袁记串串香】凭借节日营销撬动6万会员",
                        txt: "袁记把会员体系自上而下分为5级，可享受不同的优惠、不同的权益。  9元付费开卡，仅会员开卡收益这一项，袁记创下单月营收45万元+...",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRestaurant/dinner8.png",
                        title: "深耕私域流量，【九田牛】一年时间沉淀10万付费会员",
                        txt: "山东临沂，烤肉界的“扛把子”非「九田牛」莫属。小精灵开卡有礼+桌码+付费会员升级，一年积累10万付费会员！",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRestaurant/dinner9.png",
                        title: "8年磨一剑，东莞首家5星级【耶雨仙踪椰子鸡】店如何炼成？",
                        txt: "门店扫码点餐、桌边付，结合线上自建外卖商城小程序，实现会员线上线下一体化，看来get椰雨仙踪椰子鸡2000万储值的背后故事...",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRestaurant/dinner10.png",
                        title: "主动拥抱年轻消费群体，【长春藤西餐】父亲节当天核销6000+电子券",
                        txt: "「长春藤咖啡西餐」把大额储值，直接关联员工分销，让每一个服务员都变成分销员；再结合会员分层精准发券，直接实现营收的130的增长！",
                        pdf: "",
                    },
                ]
            },
            customerTalk5: {
                bg: 'rgb(245, 240, 225)',
                pic: 'img/caseRestaurant/person5.png',
                info: '“「员工分销」和「付费会员」是正餐商户的刚需，收款小精灵支持连锁门店的对账功能，总店能精准清晰的看到各个门店的财务情况，既能让门店锁定用户，又能提高员工的积极性。”',
                person: '— 王先生，九转小磨，运营经理'
            },
        }
    },
    components: {
        skeleton,
        banner,
        caseList,
        news,
        customerTalk,
        pay,
        QRCode,
        maskPDF,
        vueSeamlessScroll
    },
    computed: {
        classOption() {
            return {
                step: 0.7, // 数值越大速度滚动越快
                limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
                hoverStop: false, // 是否开启鼠标悬停stop
                direction: 2, // 0向下 1向上 2向左 3向右
                openWatch: true, // 开启数据实时监控刷新dom
                singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
            };
        },
    }
}
